import { User } from 'src/types/user';

export const USERS: User[] = [  
  {
    userId: 'ee1ac102-9ee8-485a-817c-eab9665e474f',
    firstName: 'Daniel',
    lastName: 'Beckett',
    email: 'Daniel.Beckett@email.com',
    mobileNumber: '07234567890',
    dateOfBirth: '01/01/1970',
    currentAddress: {
      addressLine1: 'Apartment 20, 2 Kingstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
    previousAddress: {
      addressLine1: 'Flat 4 Berkeley House, 27 Newstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
  },
  {
    userId: '9e54c771-feae-4951-8ef1-08e453065f4a',
    firstName: 'Danielle',
    lastName: 'Byrnes',
    email: 'Danielle.Byrnes@email.com',
    mobileNumber: '07234567890',
    dateOfBirth: '01/01/1970',
    currentAddress: {
      addressLine1: 'Apartment 20, 2 Kingstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
    previousAddress: {
      addressLine1: 'Flat 4 Berkeley House, 27 Newstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
  },
  {
    userId: '25ea72dc-e036-45d8-9839-8293208d9f82',
    firstName: 'Daniel',
    lastName: 'Cook',
    email: 'Daniel.Cook@email.com',
    mobileNumber: '07234567890',
    dateOfBirth: '01/01/1970',
    currentAddress: {
      addressLine1: 'Apartment 20, 2 Kingstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
    previousAddress: {
      addressLine1: 'Flat 4 Berkeley House, 27 Newstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
  },
  {
    userId: '2542e905-361a-4b70-b240-dd761c9702bb',
    firstName: 'Mark',
    lastName: 'Courtney',
    email: 'Mark.Courtney@email.com',
    mobileNumber: '07234567890',
    dateOfBirth: '01/01/1970',
    currentAddress: {
      addressLine1: 'Apartment 20, 2 Kingstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
    previousAddress: {
      addressLine1: 'Flat 4 Berkeley House, 27 Newstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
  },
  {
    userId: 'ecf6480a-955b-463c-8775-202dc39c0659',
    firstName: 'Lloyd',
    lastName: 'Emmerson',
    email: 'Lloyd.Emmerson@email.com',
    mobileNumber: '07234567890',
    dateOfBirth: '01/01/1970',
    currentAddress: {
      addressLine1: 'Apartment 20, 2 Kingstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
    previousAddress: {
      addressLine1: 'Flat 4 Berkeley House, 27 Newstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
  },
  {
    userId: '9e88cfb3-29b1-4b86-b709-f7bfd0b41e7e',
    firstName: 'Richard',
    lastName: 'Freedman',
    email: 'Richard.Freedman@email.com',
    mobileNumber: '07234567890',
    dateOfBirth: '01/01/1970',
    currentAddress: {
      addressLine1: 'Apartment 20, 2 Kingstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
    previousAddress: {
      addressLine1: 'Flat 4 Berkeley House, 27 Newstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
  },
  {
    userId: '33f78d4e-ec31-4530-90dd-b92eba885f7d',
    firstName: 'Mike',
    lastName: 'Haley',
    email: 'Mike.Haley@email.com',
    mobileNumber: '07234567890',
    dateOfBirth: '01/01/1970',
    currentAddress: {
      addressLine1: 'Apartment 20, 2 Kingstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
    previousAddress: {
      addressLine1: 'Flat 4 Berkeley House, 27 Newstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
  },
  {
    userId: '84ce2159-ca9f-4e03-92cb-850c63218fbd',
    firstName: 'Sophie',
    lastName: 'Lennox',
    email: 'Sophie.Lennox@email.com',
    mobileNumber: '07234567890',
    dateOfBirth: '01/01/1970',
    currentAddress: {
      addressLine1: 'Apartment 20, 2 Kingstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
    previousAddress: {
      addressLine1: 'Flat 4 Berkeley House, 27 Newstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
  },
  {
    userId: '7e853f4b-3eff-4e56-ab48-f82aa870c604',
    firstName: 'Daniel',
    lastName: 'Murphy',
    email: 'Daniel.Murphy@email.com',
    mobileNumber: '07234567890',
    dateOfBirth: '01/01/1970',
    currentAddress: {
      addressLine1: 'Apartment 20, 2 Kingstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
    previousAddress: {
      addressLine1: 'Flat 4 Berkeley House, 27 Newstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
  },
  {
    userId: '47849b99-a21d-436f-9216-1337b8fed71c',
    firstName: 'Charlotte',
    lastName: 'Sadd',
    email: 'Charlotte.Sadd@email.com',
    mobileNumber: '07234567890',
    dateOfBirth: '01/01/1970',
    currentAddress: {
      addressLine1: 'Apartment 20, 2 Kingstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
    previousAddress: {
      addressLine1: 'Flat 4 Berkeley House, 27 Newstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
  },
  {
    userId: '062f4c85-a76d-4968-a6d6-bb1d34bb3fd0',
    firstName: 'Helena',
    lastName: 'Wood',
    email: 'Helena.Wood@email.com',
    mobileNumber: '07234567890',
    dateOfBirth: '01/01/1970',
    currentAddress: {
      addressLine1: 'Apartment 20, 2 Kingstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
    previousAddress: {
      addressLine1: 'Flat 4 Berkeley House, 27 Newstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
  }, 
  {
    userId: 'bdf9521e-39bf-471f-a7a9-f6867774acad',
    firstName: 'Apadmi',
    lastName: 'Test+4',
    email: 'apadmitest+4@apadmi.com',
    mobileNumber: '07234567890',
    dateOfBirth: '01/01/1970',
    currentAddress: {
      addressLine1: 'Apartment 20, 2 Kingstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
    previousAddress: {
      addressLine1: 'Flat 4 Berkeley House, 27 Newstreet',
      city: 'Worcester',
      postCode: 'SW1A 1AA',
    },
  },
];
